import { __styles, mergeClasses, shorthands } from '@griffel/react';
import { tokens } from '@fluentui/react-theme';
import { createFocusOutlineStyle } from '@fluentui/react-tabster';
import { MEDIA_QUERY_BREAKPOINT_SELECTOR, SURFACE_BORDER_RADIUS, SURFACE_BORDER_WIDTH, SURFACE_PADDING, useDialogContext_unstable } from '../../contexts';
export const dialogSurfaceClassNames = {
  root: 'fui-DialogSurface',
  backdrop: 'fui-DialogSurface__backdrop'
};
/**
 * Styles for the root slot
 */

const useStyles = /*#__PURE__*/__styles({
  "focusOutline": {
    "Brovlpu": "ftqa4ok",
    "B486eqv": "f2hkw1w",
    "B8q5s1w": "f8hki3x",
    "Bci5o5g": ["f1d2448m", "ffh67wi"],
    "n8qw10": "f1bjia2o",
    "Bdrgwmp": ["ffh67wi", "f1d2448m"],
    "Bm4h7ae": "f15bsgw9",
    "B7ys5i9": "f14e48fq",
    "Busjfv9": "f18yb2kv",
    "Bhk32uz": "fd6o370",
    "Bf4ptjt": "fh1cnn4",
    "kclons": ["fy7oxxb", "f184ne2d"],
    "Bhdgwq3": "fpukqih",
    "Blkhhs4": ["f184ne2d", "fy7oxxb"],
    "Bqtpl0w": "frrh606",
    "clg4pj": ["f1v5zibi", "fo2hd23"],
    "hgwjuy": "ful5kiu",
    "Bonggc9": ["fo2hd23", "f1v5zibi"],
    "B1tsrr9": ["f1jqcqds", "ftffrms"],
    "Dah5zi": ["ftffrms", "f1jqcqds"],
    "Bkh64rk": ["f2e7qr6", "fsr1zz6"],
    "qqdqy8": ["fsr1zz6", "f2e7qr6"],
    "B6dhp37": "f1dvezut",
    "i03rao": ["fd0oaoj", "f1cwg4i8"],
    "Boxcth7": "fjvm52t",
    "Bsom6fd": ["f1cwg4i8", "fd0oaoj"],
    "J0r882": "fdiulkx",
    "Bjwuhne": "f1yalx80",
    "Ghsupd": ["fq22d5a", "f1jw7pan"],
    "Bule8hv": ["f1jw7pan", "fq22d5a"]
  },
  "root": {
    "mc9l5x": "ftgm304",
    "famaaq": "f1c515w",
    "Bcdw1i0": "f1bitti",
    "Bhzewxz": "f15twtuk",
    "j35jbq": ["f1e31b4d", "f1vgc2s3"],
    "B5kzvoi": "f1yab3r1",
    "oyh7mz": ["f1vgc2s3", "f1e31b4d"],
    "z8tnut": "fuq56rw",
    "z189sj": ["f15kemlc", "fdgang7"],
    "Byoj8tv": "fl2zwns",
    "uwmqm3": ["fdgang7", "f15kemlc"],
    "B6of3ja": "fgr6219",
    "t21cq0": ["f1ujusj6", "fcgxt0o"],
    "jrapky": "f10jk5vf",
    "Frg6f3": ["fcgxt0o", "f1ujusj6"],
    "icvyot": "fzkkow9",
    "vrafjx": ["fcdblym", "fjik90z"],
    "oivjwe": "fg706s2",
    "wvpqe5": ["fjik90z", "fcdblym"],
    "B68tc82": "f1ln0qer",
    "Bmxbyg5": "fa2wlxz",
    "fshzfu": "f120kxnn",
    "qhf8xq": "f19dog8a",
    "a9b677": "fly5x3f",
    "Bqenvij": "f3052tw",
    "B2u0y6b": "fvgz9i8",
    "Bxyxcbc": "f6a9g1z",
    "B7ck84d": "f1ewtqcl",
    "E5pizo": "f10nrhrw",
    "De3pzq": "fxugw4r",
    "sj55zd": "f19n0e5",
    "B4j52fo": "f5ogflp",
    "Bekrc4i": ["f1hqa2wf", "finvdd3"],
    "Bn0qgzm": "f1f09k3d",
    "ibv6hh": ["finvdd3", "f1hqa2wf"],
    "g2u3we": "fghlq4f",
    "h3c5rm": ["f1gn591s", "fjscplz"],
    "B9xav0g": "fb073pr",
    "zhjwy3": ["fjscplz", "f1gn591s"],
    "Bbmb7ep": ["f1erghxr", "f1ehz9de"],
    "Beyfa6y": ["f1ehz9de", "f1erghxr"],
    "B7oj6ja": ["f1spoy8", "fmb70yw"],
    "Btl43ni": ["fmb70yw", "f1spoy8"],
    "B5xtmjs": "ff54dml"
  },
  "backdrop": {
    "qhf8xq": "f19dog8a",
    "De3pzq": "fju19wo",
    "Bhzewxz": "f113wtx2",
    "j35jbq": ["f10k790i", "f1xynx9j"],
    "B5kzvoi": "f5gq2j6",
    "oyh7mz": ["f1xynx9j", "f10k790i"]
  },
  "nestedDialogBackdrop": {
    "De3pzq": "f3rmtva"
  },
  "nestedNativeDialogBackdrop": {
    "fshzfu": "foe20jx"
  }
}, {
  "f": [".ftqa4ok:focus{outline-style:none;}"],
  "i": [".f2hkw1w:focus-visible{outline-style:none;}"],
  "d": [".f8hki3x[data-fui-focus-visible]{border-top-color:transparent;}", ".f1d2448m[data-fui-focus-visible]{border-right-color:transparent;}", ".ffh67wi[data-fui-focus-visible]{border-left-color:transparent;}", ".f1bjia2o[data-fui-focus-visible]{border-bottom-color:transparent;}", ".f15bsgw9[data-fui-focus-visible]::after{content:\"\";}", ".f14e48fq[data-fui-focus-visible]::after{position:absolute;}", ".f18yb2kv[data-fui-focus-visible]::after{pointer-events:none;}", ".fd6o370[data-fui-focus-visible]::after{z-index:1;}", ".fh1cnn4[data-fui-focus-visible]::after{border-top-style:solid;}", ".fy7oxxb[data-fui-focus-visible]::after{border-right-style:solid;}", ".f184ne2d[data-fui-focus-visible]::after{border-left-style:solid;}", ".fpukqih[data-fui-focus-visible]::after{border-bottom-style:solid;}", ".frrh606[data-fui-focus-visible]::after{border-top-width:2px;}", ".f1v5zibi[data-fui-focus-visible]::after{border-right-width:2px;}", ".fo2hd23[data-fui-focus-visible]::after{border-left-width:2px;}", ".ful5kiu[data-fui-focus-visible]::after{border-bottom-width:2px;}", ".f1jqcqds[data-fui-focus-visible]::after{border-bottom-right-radius:var(--borderRadiusMedium);}", ".ftffrms[data-fui-focus-visible]::after{border-bottom-left-radius:var(--borderRadiusMedium);}", ".f2e7qr6[data-fui-focus-visible]::after{border-top-right-radius:var(--borderRadiusMedium);}", ".fsr1zz6[data-fui-focus-visible]::after{border-top-left-radius:var(--borderRadiusMedium);}", ".f1dvezut[data-fui-focus-visible]::after{border-top-color:var(--colorStrokeFocus2);}", ".fd0oaoj[data-fui-focus-visible]::after{border-right-color:var(--colorStrokeFocus2);}", ".f1cwg4i8[data-fui-focus-visible]::after{border-left-color:var(--colorStrokeFocus2);}", ".fjvm52t[data-fui-focus-visible]::after{border-bottom-color:var(--colorStrokeFocus2);}", ".fdiulkx[data-fui-focus-visible]::after{top:-2px;}", ".f1yalx80[data-fui-focus-visible]::after{bottom:-2px;}", ".fq22d5a[data-fui-focus-visible]::after{left:-2px;}", ".f1jw7pan[data-fui-focus-visible]::after{right:-2px;}", ".ftgm304{display:block;}", ".f1c515w{-webkit-user-select:unset;-moz-user-select:unset;-ms-user-select:unset;user-select:unset;}", ".f1bitti{visibility:unset;}", ".f15twtuk{top:0;}", ".f1e31b4d{right:0;}", ".f1vgc2s3{left:0;}", ".f1yab3r1{bottom:0;}", ".fuq56rw{padding-top:24px;}", ".f15kemlc{padding-right:24px;}", ".fdgang7{padding-left:24px;}", ".fl2zwns{padding-bottom:24px;}", ".fgr6219{margin-top:auto;}", ".f1ujusj6{margin-right:auto;}", ".fcgxt0o{margin-left:auto;}", ".f10jk5vf{margin-bottom:auto;}", ".fzkkow9{border-top-style:solid;}", ".fcdblym{border-right-style:solid;}", ".fjik90z{border-left-style:solid;}", ".fg706s2{border-bottom-style:solid;}", ".f1ln0qer{overflow-x:unset;}", ".fa2wlxz{overflow-y:unset;}", ".f120kxnn::backdrop{background-color:rgba(0, 0, 0, 0.4);}", ".f19dog8a{position:fixed;}", ".fly5x3f{width:100%;}", ".f3052tw{height:-webkit-fit-content;height:-moz-fit-content;height:fit-content;}", ".fvgz9i8{max-width:600px;}", ".f6a9g1z{max-height:100vh;}", ".f1ewtqcl{box-sizing:border-box;}", ".f10nrhrw{box-shadow:var(--shadow64);}", ".fxugw4r{background-color:var(--colorNeutralBackground1);}", ".f19n0e5{color:var(--colorNeutralForeground1);}", ".f5ogflp{border-top-width:1px;}", ".f1hqa2wf{border-right-width:1px;}", ".finvdd3{border-left-width:1px;}", ".f1f09k3d{border-bottom-width:1px;}", ".fghlq4f{border-top-color:var(--colorTransparentStroke);}", ".f1gn591s{border-right-color:var(--colorTransparentStroke);}", ".fjscplz{border-left-color:var(--colorTransparentStroke);}", ".fb073pr{border-bottom-color:var(--colorTransparentStroke);}", ".f1erghxr{border-bottom-right-radius:8px;}", ".f1ehz9de{border-bottom-left-radius:8px;}", ".f1spoy8{border-top-right-radius:8px;}", ".fmb70yw{border-top-left-radius:8px;}", ".fju19wo{background-color:rgba(0, 0, 0, 0.4);}", ".f113wtx2{top:0px;}", ".f10k790i{right:0px;}", ".f1xynx9j{left:0px;}", ".f5gq2j6{bottom:0px;}", ".f3rmtva{background-color:transparent;}", ".foe20jx::backdrop{background-color:transparent;}"],
  "m": [["@media screen and (max-width: 480px){.ff54dml{max-width:100vw;}}", {
    "m": "screen and (max-width: 480px)"
  }]]
});
/**
 * Apply styling to the DialogSurface slots based on the state
 */


export const useDialogSurfaceStyles_unstable = state => {
  const styles = useStyles();
  const isNestedDialog = useDialogContext_unstable(ctx => ctx.isNestedDialog);
  state.root.className = mergeClasses(dialogSurfaceClassNames.root, styles.root, styles.focusOutline, isNestedDialog && styles.nestedNativeDialogBackdrop, state.root.className);

  if (state.backdrop) {
    state.backdrop.className = mergeClasses(dialogSurfaceClassNames.backdrop, styles.backdrop, isNestedDialog && styles.nestedDialogBackdrop, state.backdrop.className);
  }

  return state;
};
//# sourceMappingURL=useDialogSurfaceStyles.js.map